/**
 * maxFileSize - in KB
 */
export const validateImage = async (file: File, maxFileSize = 500, formattedMaxFileSize?: string) =>
  new Promise<void>((resolve, reject) => {
    try {
      if (file.size > maxFileSize * 1024) {
        reject(
          new Error(
            `The image file size must be less than ${formattedMaxFileSize || `${maxFileSize}KB`}`,
          ),
        );

        return;
      }

      resolve();
    } catch (err) {
      reject(err);
    }
  });
